<ngx-sonner-toaster
  position="top-right"
  theme="light"
  [richColors]="true"
  [closeButton]="true"
  [duration]="4000"
  [visibleToasts]="3"
/>
<router-outlet />

@if (resolving()) {
  <app-loader />
}
